import React from 'react';
import { interpolate } from '@popmotion/popcorn';
var leftScrollShadow = interpolate([0, 0.2], [0, 1]);
var rightScrollShadow = interpolate([0.8, 1], [1, 0]);

function ScrollShadow(_ref) {
  var _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      position = _ref.position,
      progress = _ref.progress;
  var scrollProgress = isNaN(progress) ? 0 : progress;
  var style = {
    width: 10,
    position: 'absolute',
    top: 0,
    bottom: 0,
    zIndex: 30,
    pointerEvents: 'none'
  };

  if (position === 'left') {
    style.left = offset;
    style.background = 'linear-gradient(-90deg, transparent 4px, rgba(125, 125, 125, 0.15))';
    style.opacity = leftScrollShadow(scrollProgress);
  } else {
    style.right = offset;
    style.background = 'linear-gradient(90deg, transparent 4px, rgba(125, 125, 125, 0.15))';
    style.opacity = rightScrollShadow(scrollProgress);
  }

  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    style: style
  });
}

export default ScrollShadow;